<div class="app-shell" [attr.data-portfolio]="isPortfolio">
  <!-- Top-left: brand pill (logo + dynamic breadcrumb) -->
  <div class="float-zone float-top-left">
    <div class="glass brand-pill">
      <a class="logo-mark" [routerLink]="['/app/']" title="Cimalti">
        <img src="../../../assets/images/logo-min-white.svg" alt="Cimalti" />
      </a>
      <nav class="crumbs" aria-label="breadcrumb">
        @if (isPortfolio && portfolio?.id) {
          <a [routerLink]="['/app/']" class="crumb-link">Portfolios</a>
          <span class="crumb-sep">›</span>
          <strong class="crumb-current">{{
            portfolio?.name || "Portfolio"
          }}</strong>
        } @else {
          <strong class="crumb-current">{{ pageTitle }}</strong>
        }
      </nav>
    </div>
  </div>

  <!-- Top-center: portfolio section tabs (only in portfolio mode) -->
  @if (isPortfolio && portfolioIdFromUrl) {
    <div class="float-zone float-top-center">
      <nav class="glass step-tabs" aria-label="Portfolio sections">
        @for (tab of portfolioTabs; track tab.id) {
          <a
            [routerLink]="tab.link(portfolioIdFromUrl)"
            class="step-tab"
            [class.active]="isTabActive(tab)"
          >
            {{ tab.label }}
          </a>
        }
      </nav>
    </div>
  }

  <!-- Bottom-left: vertical utility pill (portfolios / width / theme / settings / admin / sign out) -->
  <aside class="float-zone float-bottom-left">
    <div class="glass util-pill">
      <div class="tooltip-host">
        <a
          class="nav-ico"
          [routerLink]="['/app/']"
          [routerLinkActiveOptions]="{ exact: true }"
          routerLinkActive="active"
          aria-label="My portfolios"
        >
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.6"
            stroke-linejoin="round"
          >
            <rect x="3" y="4" width="18" height="6" rx="2" />
            <rect x="3" y="14" width="18" height="6" rx="2" />
          </svg>
        </a>
        <span class="tooltip">My portfolios</span>
      </div>

      <span class="divider"></span>

      <div class="tooltip-host">
        <button
          class="nav-ico"
          type="button"
          (click)="toggleContainerWidth()"
          [attr.aria-label]="
            containerWidth === 'fixed'
              ? 'Switch to full width layout'
              : 'Switch to fixed width layout'
          "
        >
        @if (containerWidth === "fixed") {
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.6"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <polyline points="8 3 3 3 3 8" />
            <polyline points="16 3 21 3 21 8" />
            <polyline points="3 16 3 21 8 21" />
            <polyline points="21 16 21 21 16 21" />
          </svg>
        }
        @if (containerWidth === "fluid") {
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.6"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <polyline points="3 8 8 8 8 3" />
            <polyline points="16 3 16 8 21 8" />
            <polyline points="3 16 8 16 8 21" />
            <polyline points="16 21 16 16 21 16" />
          </svg>
        }
        </button>
        <span class="tooltip">{{
          containerWidth === "fixed" ? "Full width" : "Fixed width"
        }}</span>
      </div>

      <div class="tooltip-host">
        <button
          class="nav-ico"
          type="button"
          (click)="toggleTheme()"
          [attr.aria-label]="
            theme === 'dark' ? 'Switch to light theme' : 'Switch to dark theme'
          "
        >
        @if (theme === "dark") {
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.6"
          >
            <path d="M21 13a9 9 0 11-10-10 7 7 0 0010 10z" />
          </svg>
        }
        @if (theme === "light") {
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.6"
          >
            <circle cx="12" cy="12" r="4" />
            <path
              d="M12 2v2M12 20v2M2 12h2M20 12h2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"
            />
          </svg>
        }
        </button>
        <span class="tooltip">{{
          theme === "dark" ? "Light theme" : "Dark theme"
        }}</span>
      </div>
      <span class="divider"></span>
      <div class="tooltip-host">
        <a
          class="nav-ico"
          [routerLink]="['/app/settings']"
          routerLinkActive="active"
          aria-label="Settings"
        >
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="1.6"
          stroke-linejoin="round"
        >
          <circle cx="12" cy="12" r="3" />
          <path
            d="M19.4 15a1.7 1.7 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.8-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1-1.5 1.7 1.7 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.8 1.7 1.7 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.5-1 1.7 1.7 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.8.3h.1a1.7 1.7 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.8v.1a1.7 1.7 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1z"
          />
        </svg>
        </a>
        <span class="tooltip">Settings</span>
      </div>

      @if (isAdmin) {
        <div class="tooltip-host">
          <a
            class="nav-ico"
            [routerLink]="['/app/users']"
            routerLinkActive="active"
            aria-label="Admin"
          >
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.6"
              stroke-linejoin="round"
            >
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" />
              <path d="M22 21v-2a4 4 0 0 0-3-3.9" />
              <path d="M16 3.1A4 4 0 0 1 16 11" />
            </svg>
          </a>
          <span class="tooltip">Admin</span>
        </div>
      }

      <span class="divider"></span>

      <div class="tooltip-host">
        <button
          class="nav-ico nav-ico--logout"
          type="button"
          (click)="onLogout()"
          aria-label="Sign out"
        >
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.6"
            stroke-linejoin="round"
          >
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
            <path d="M16 17l5-5-5-5" />
            <path d="M21 12H9" />
          </svg>
        </button>
        <span class="tooltip">Sign out</span>
      </div>
    </div>
  </aside>

  <main class="main">
    <router-outlet #o="outlet" class="main-router-outlet"></router-outlet>
  </main>
</div>
